import { Typography } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";
import { DialogProps } from "types";

interface Props extends DialogProps {
  description: any;
}

function ViewLogHour({ open, setOpen, description }: Props) {
  return (
    <DialogWrapper title="Log Hour Description" open={open} setOpen={setOpen}>
        <Typography>{description}</Typography>
    </DialogWrapper>
  );
}

export default ViewLogHour;
